import { Theme } from '@/layouts/token-studio'

export const getThemePaths = (obj: Theme, prefix = ''): string[] => {
  const paths: string[] = []

  if (obj && typeof obj === 'object' && !Array.isArray(obj)) {
    Object.keys(obj).forEach(key => {
      const currentPath = prefix ? `${prefix}.${key}` : key
      const value = obj[key as keyof Theme]

      if (value && typeof value === 'object' && !Array.isArray(value) && value.value !== undefined) {
        paths.push(currentPath)
      } else if (value && typeof value === 'object' && !Array.isArray(value)) {
        // @ts-ignore
        paths.push(...getThemePaths(value, currentPath))
      }
    })
  }

  return paths
}
